import { z } from 'zod';

export const fsDirectoryFilterSettingsSchema = z.object({
  idFSDirectoryType: z.number(),
  idFSDirectoryArray: z.array(z.number()),
  create_time_filter: z.number(),
  show_empty_directories: z.boolean(),
  show_sorted_directories: z.boolean(),
});

export const IFsDirectorySchema = z.object({
  idFSDirectory: z.number(),
  idFSDirectoryType: z.number(),
  idFSDirectoryProtocol: z.number(),
  idFSDirectoryAuthentication: z.number(),
  OriginPath: z.string(),
  Name: z.string(),
  Server: z.string(),
  User: z.string(),
  Password: z.string().nullable(),
});

export const IFSScanResultSchema = z.object({
  fileName: z.string(),
  idFSDirectory: z.number(),
  path: z.string(),
  created_at: z.string(),
  isSorted: z.boolean(),
});

export const FSSelectObjectSchema = z.object({
  section: z
    .enum(['certificate', 'invoice', 'dms', 'legalRequirements'])
    .or(z.string()),
  idDocumentDirectory: z.number(),
  idLegalRequirement: z.number(),
  FSScanResult: IFSScanResultSchema,
});

export type IFSScanResult = z.infer<typeof IFSScanResultSchema>;
export type IFsDirectoryFilterSettings = z.infer<
  typeof fsDirectoryFilterSettingsSchema
>;
export type IFSDirectory = z.infer<typeof IFsDirectorySchema>;

export type IFSSelectObject = z.infer<typeof FSSelectObjectSchema>;

export const getInitialFilterObject = (): IFsDirectoryFilterSettings => {
  return {
    idFSDirectoryType: 0,
    idFSDirectoryArray: [],
    create_time_filter: 1,
    show_empty_directories: true,
    show_sorted_directories: true,
  };
};

export const getEmptyFSSelectObject = (fsScanObject: IFSScanResult) => {
  return {
    section: 'legalRequirements',
    idDocumentDirectory: -1,
    idLegalRequirement: -1,
    FSScanResult: fsScanObject,
  } as IFSSelectObject;
};
